export interface BoardWorkItemRow {
  id: string;
  name: string;
  type: string;
  status: string;
  rank: number;
  parent_work_item_id: string | null;
  due_date: string | null;
  created_at: string | null;
  created_by: string | null;
  updated_at: string | null;
  assignee_id: string | null;
  priority: string | null;
}

export const BOARD_FALLBACK_STAGES: ReadonlyArray<string> = [
  'Backlog',
  'In progress',
  'Review',
  'Done'
];

export const BOARD_CHIP_KEYS: ReadonlyArray<string> = [
  'type',
  'status',
  'assignee',
  'priority',
  'due',
  'epic'
];

export const BOARD_CHIP_LABELS: Readonly<Record<string, string>> = {
  type: 'Type',
  status: 'Status',
  assignee: 'Assignee',
  priority: 'Priority',
  due: 'Due',
  epic: 'Epic'
};
